export const TEST_ID = 'mixRateRow';

export const AMOUNT_UNIT_OPTIONS = [
    { key: 'FL_OZ', value: 'fl oz' },
    { key: 'PT', value: 'pt' },
    { key: 'QT', value: 'qt' },
    { key: 'GAL', value: 'gal' },
    { key: 'ML', value: 'mL' },
    { key: 'L', value: 'L' },
    { key: 'OZ_WT', value: 'oz' },
    { key: 'LB', value: 'lb' },
    { key: 'G', value: 'g' },
    { key: 'KG', value: 'kg' }
] as const;

export const PER_UNIT_OPTIONS = [
    { key: 'ACRE', value: 'acre' },
    { key: 'HA', value: 'ha' },
    { key: 'SQ_FT_1000', value: '1,000 sq ft' },
    { key: 'GAL_WATER_100', value: '100 gal water' },
    { key: 'GAL_WATER_1000', value: '1,000 gal water' }
] as const;
